import { connect } from "react-redux";
import sortBy from "lodash/sortBy";
import Fuse from "fuse.js";
import { formValueSelector } from "redux-form";
import TaggingField from "common/components/form_fields/tagging";
import { getSubCategories, excludeDeprecated } from "common/ducks/categories";
import { createTermRequest } from "searched_terms/ducks";
import { CONTEXT_SUBCAT_SEARCH } from "searched_terms/constants";
import { SUBCAT_SEARCH_FUZZY_OPTS } from "common/variables";

const fuzzyFilterOptions = (options, value) => {
  if (!value.trim()) {
    return options;
  }

  const fuse = new Fuse(options, {
    ...SUBCAT_SEARCH_FUZZY_OPTS,
    keys: ["label", "keywords"],
  });
  const results = fuse.search(value);
  return results.map((r) => r.item);
};

const mapStateToProps = (
  state,
  { value, formName, includeAllOption, include1to1Option, categories, input }
) => {
  const { name } = input;
  const cats =
    categories ||
    excludeDeprecated(state.categories.data).filter((c) => !c.is_one_to_one);
  const subcategories = sortBy(getSubCategories({ data: cats }), "name");
  let selector, formValue;
  const options = subcategories.map((subcat) => ({
    label: subcat.name,
    value: subcat.id,
    keywords: subcat.keywords,
  }));

  if (include1to1Option) {
    options.unshift({ label: "1-to-1", value: "1to1" });
  }

  if (includeAllOption) {
    options.unshift({ label: "All", value: "all" });
  }

  if (formName) {
    selector = formValueSelector(formName);
    formValue = selector(state, name);
  }

  return {
    options,
    value: formName ? formValue : value,
    clearable: false,
    input: {
      onInputChange: (content) =>
        createTermRequest({ content, context: CONTEXT_SUBCAT_SEARCH }),
      filterOptions: fuzzyFilterOptions,
      ...input,
    },
  };
};

export default connect(mapStateToProps)(TaggingField);
